import { FilterOption } from '../interfaces/FilterOption';
import BaseService from './base.service';
import MapToFilterOptions from '../helpers/mapToFilterOption';

class LanguagesService {
  public static getAllByParams(column?: string, inputValue?: string): Promise<FilterOption[]> {
    return BaseService.getAllByParams('languages', column, inputValue)
      .then((languages) => {

        return MapToFilterOptions.mapToFilterOptions(languages);
      }).catch((error: Error) => {
        throw error;
      });
  }
}

export default LanguagesService;
